'use strict';

var availabilityStatusPill = {};

exports.__exports = availabilityStatusPill;
//# sourceMappingURL=availabilityStatusPill.cjs.map
